import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Layout"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.7552 1.79116C11.9139 1.73628 12.0865 1.73628 12.2453 1.79116L22.2453 5.24831C22.5465 5.35245 22.749 5.63558 22.7502 5.95429C22.7515 6.27299 22.5511 6.55766 22.2507 6.66409L12.2507 10.2069C12.0887 10.2644 11.9118 10.2644 11.7498 10.2069L1.74978 6.66409C1.44937 6.55766 1.24903 6.27299 1.25025 5.95429C1.25147 5.63558 1.45397 5.35245 1.75519 5.24831L11.7552 1.79116ZM4.27058 5.96582L12.0002 8.70432L19.7299 5.96582L12.0002 3.29355L4.27058 5.96582Z"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.53996 9.04492L12.0001 12.706L22.4602 9.04492L22.9557 10.4607L12.2479 14.2085C12.0874 14.2646 11.9127 14.2646 11.7523 14.2085L1.04443 10.4607L1.53996 9.04492Z"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.53996 13.0439L12.0001 16.705L22.4602 13.0439L22.9557 14.4597L12.2479 18.2075C12.0874 18.2636 11.9127 18.2636 11.7523 18.2075L1.04443 14.4597L1.53996 13.0439Z"
}, null, -1);
const _hoisted_5 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.53996 17.0459L12.0001 20.7069L22.4602 17.0459L22.9557 18.4617L12.2479 22.2094C12.0874 22.2656 11.9127 22.2656 11.7523 22.2094L1.04443 18.4617L1.53996 17.0459Z"
}, null, -1);
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Layout.vue"]]);
